import React from 'react';
import { GluestackUIProvider } from '../../core';
import { config } from '@tonic/central-specialties-ui-config';
export const CentralSpecialtiesUIProvider = ({ children, }) => {
    return React.createElement(GluestackUIProvider, { config: config }, children);
};
